import React from 'react';

const PlusIcons: React.FC = () => {
  return (
    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.3335 6.16634H0.333496V4.83301H4.3335V0.833008H5.66683V4.83301H9.66683V6.16634H5.66683V10.1663H4.3335V6.16634Z"
        fill="#242424"
      />
    </svg>
  );
};

export default PlusIcons;
